import { Navigate, Params, useParams } from "react-router-dom";

export const redirectTo = (buildPath: (params: Readonly<Params<string>>) => string) => {
    const RouteRedirect = () => {
        const params = useParams();
        return <Navigate to={buildPath(params)} replace />;
    };
    return RouteRedirect;
};
